var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"achievement-widget",on:{"click":_vm.trigger}},[_c('div',{staticClass:"achievement-badge",class:_vm.badgeClass},[_vm._v("\n    "+_vm._s(_vm.$store.state.achievement.count)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }